import { render, staticRenderFns } from "./VideoPlyrPlaylist.vue?vue&type=template&id=e22352a2&"
import script from "./VideoPlyrPlaylist.vue?vue&type=script&lang=js&"
export * from "./VideoPlyrPlaylist.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlyrPlaylist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports